module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "table-data"
  }, [_c('table', [_c('thead', [_c('tr', _vm._l((_vm.tableInfo.title), function(item) {
    return _c('th', {
      style: (item.style)
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), (_vm.tableInfo.data && _vm.tableInfo.data.length > 0) ? _c('tbody', _vm._l((_vm.tableInfo.data), function(item) {
    return _c('tr', _vm._l((item), function(val) {
      return _c('td', {
        style: (val.style),
        attrs: {
          "title": _vm.formatTitle(val.value)
        },
        domProps: {
          "innerHTML": _vm._s(val.value === null ? '--' : val.value)
        },
        on: {
          "click": function($event) {
            val.showTc ? _vm.showTc(val.params) : function() {}
          }
        }
      })
    }))
  })) : _vm._e(), _vm._v(" "), (!_vm.tableInfo.data || _vm.tableInfo.data.length === 0) ? _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": _vm.tableInfo.title.length
    }
  }, [_vm._v("暂无数据")])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a35b02","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/table/Table.vue
// module id = 679
// module chunks = 0